import axios from 'axios';

export const axiosOutcomesAssessmentInstance = axios.create({
  baseURL: process.env.REACT_APP_OUTCOMES_ASSESSMENT_SERVICE_URL,
});

axiosOutcomesAssessmentInstance.defaults.headers.post['Content-Type'] =
  'application/json;charset=utf-8';
axiosOutcomesAssessmentInstance.defaults.headers.post[
  'Access-Control-Allow-Origin'
] = '*';
axiosOutcomesAssessmentInstance.defaults.headers.common['x-tenant-id'] =
  'default';

export const getOutcomesAssessmentRequest = (path, config = {}) => {
  return axiosOutcomesAssessmentInstance.get(path, config);
};

export const putOutcomesAssessmentRequest = (path, body, config = {}) => {
  return axiosOutcomesAssessmentInstance.put(path, body, config);
};

export const patchOutcomesAssessmentRequest = (path, body, config = {}) => {
  return axiosOutcomesAssessmentInstance.patch(path, body, config);
};

export const postOutcomesAssessmentRequest = (path, body, config = {}) => {
  return axiosOutcomesAssessmentInstance.post(path, body, config);
};

export const deleteOutcomesAssessmentRequest = (path, config = {}) => {
  return axiosOutcomesAssessmentInstance.delete(path, config);
};
